// 'use strict';
import InteractiveWheel from './components/InteractiveWheel';
import ToolSubmitTiles from './components/ToolSubmitTilesNoWheel';
import LoginButton from './components/LoginButton';
import WheelBackButton from './components/WheelBackButton';
// import LiveSearch from './components/LiveSearch';

import './css/general.css';

console.log("on a subject windon: ",window.location.href.includes("/subject"), window.location.href)

const domContainer = document.querySelector('#interactive_wheel');
if(domContainer){ReactDOM.render(<InteractiveWheel use='search'/>, domContainer)};

// we can provide a second container to render the component in a different place
const domContainer2 = document.querySelector('#htmlTestInsert');
if(domContainer2){ReactDOM.render(<ToolSubmitTiles />, domContainer2)};

const domContainer3 = document.querySelector('#login-button');
if(domContainer3){ReactDOM.render(<LoginButton />, domContainer3)}; 

var temp = document.createElement('div');
ReactDOM.render(<WheelBackButton />, temp);
document.querySelector('#main').appendChild(temp);

// const domContainer4 = document.querySelector('#customLiveSearch');
// if(domContainer4){ReactDOM.render(<LiveSearch />, domContainer4)}; 